import { Component, OnInit } from '@angular/core';

import { ApiService, DataService } from './services';

@Component({
    selector: 'app',
    template: require('./app.component.html'),
    styles: [require('./app.component.css')]
})
export class AppComponent {

    public practiceDeteced: boolean = true;
    public estTitle: string;

    constructor(public apiService: ApiService, public dataService: DataService) {
        this.setPracticeFullName()
    }

    public setPracticeFullName() {
        this.apiService.get('/estatements/practiceName').subscribe(resp => {
            if (resp.success) {
                this.estTitle = resp.estTitle;
                this.dataService.practiceId = resp.pId;
                this.dataService.companyName = resp.cName;
                this.dataService.billingPhone = resp.billingPhone;
                this.dataService.maxFailedCount = resp.maxFailedCount;
                this.dataService.failedMinutes = resp.failedMinutes;
            }
            else {
                this.practiceDeteced = false;
            }
        })
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/app.component.ts